import { createSlice } from '@reduxjs/toolkit';
import { createAsyncAction } from '../action/index';

const getTeleSession = createAsyncAction('getTeleSession', 'getTeleSession');

interface InitialState {
  isFetchingTeleAppointment: boolean,
  teleConsultSessionId: string;
  teleChannelUuid: string;
}

const initialState = {
  isFetchingTeleAppointment: false,
  teleConsultSessionId: '',
  teleChannelUuid: '',
} as InitialState;

export const counterSlice = createSlice({
  name: 'agora',
  initialState,
  reducers: {
    updateAgoraState: (state, action) => Object.assign(state, action.payload),
  },
  extraReducers: {
    [getTeleSession.pending as any]: (state) => {
      state.isFetchingTeleAppointment = true;
    },
    [getTeleSession.fulfilled as any]: (state, { payload }) => {
      state.teleChannelUuid = payload.channel_uuid;
      state.isFetchingTeleAppointment = false;
    },
    [getTeleSession.rejected as any]: (state) => {
      state.isFetchingTeleAppointment = false;
    },
  },
});

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount, } = counterSlice.actions
const { updateAgoraState } = counterSlice.actions;
export {
  updateAgoraState,
  getTeleSession,
};
export default counterSlice.reducer;